<template>
  <Navbar :center-text="$t('logut')"
          :message="this.message"
          :message-type="this.messageType"></Navbar>
  <Footerbar></Footerbar>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
export default {
  components: {Footerbar, Navbar},
  data() {
    return {
      message: "Logout successful",
      messageType: "success",
    }
  }
}
</script>